import { createApiSlice } from "@common";
import { CRUD_PRODUCT_CATEGORY } from "@routes";

const apiConfig = [
  {
    name: "addProductCategory",
    method: "post",
    url: CRUD_PRODUCT_CATEGORY,
    stateKey: "message"
  },
  {
    name: "getProductCategory",
    method: "get",
    url: CRUD_PRODUCT_CATEGORY,
    stateKey: "data"
  },
  {
    name: "updateProductCategory",
    method: "put",
    url: CRUD_PRODUCT_CATEGORY,
    stateKey: "message"
  },
  {
    name: "deleteProductCategory",
    method: "delete",
    url: CRUD_PRODUCT_CATEGORY,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("productCategory", apiConfig, customReducers);
const productCategorySlice = slice;

export default productCategorySlice.reducer;

export const {
  addProductCategory,
  getProductCategory,
  updateProductCategory,
  deleteProductCategory
} = thunks;
export const {
  rowSelect
} = actions;
